import * as APIActionTypes from './api/actionTypes';
import * as AppActionTypes from './application/actionTypes';
import * as AuthActionTypes from './authentication/actionTypes';
import * as FormActionTypes from './form/actionTypes';
import * as SaveActionTypes from './save/actionTypes';
import * as SectionActionTypes from './section/actionTypes';
import * as NavigateActionTypes from './navigate/actionTypes';

/**
 * RootActionTypes contains the action types for all redux modules.
 *
 * Warning: Be careful about referencing this within `@redux/modules`, as there
 * is a possibility for circular dependencies.
 */
export const RootActionTypes = {
  api: APIActionTypes,
  application: AppActionTypes,
  authentication: AuthActionTypes,
  form: FormActionTypes,
  save: SaveActionTypes,
  section: SectionActionTypes,
  navigate: NavigateActionTypes,
};
